import { identify as identifyAnalytics } from '@sloyd/analytics';
import * as api from '@sloyd/api';
import { identify as identifyPay } from '@sloyd/pay';
import { actions, idbPatchState, selectors } from '@sloyd/store-base';
import { toast } from '@sloyd/ui';
import { delay, put, select, takeEvery } from 'saga-ts';
import { $a, invokeEvent, l, setBoolean } from 'shared-base';
import { customEventChannel } from './channels/channel.customEvent';

// Fetch data from multiple API endpoints
export function* fetchUser(ev: any): Generator<any, void, any> {
  try {
    console.time('saga|fetchUser');
    yield delay(150);

    const user = yield select(selectors.base.$user);

    if (!user.sub) {
      return;
    }

    const resUser = yield api.user.get(user.sub);

    if (!resUser.data) {
      return;
    }

    try {
      const { sub, email } = user;
      const { planId } = resUser.data;
      const isPayingUser = planId.startsWith('pro');
      identifyAnalytics({ sub, email, isPaying: isPayingUser });
      identifyPay(email);

      if (!isPayingUser) {
        yield put($a('ONBOARDING', 'special'));
        yield put($a('ONBOARDING', 'show'));
      }
    } catch (err) {
      console.log('err =>', err);
    }

    const dataUser = resUser.data ?? {};
    const { email = '', isAlpha, planId } = dataUser;

    if (planId === 'popular') {
      const resApi = yield api.user.getApi();
      const dataApi = resApi.data ?? {};
      dataUser.clientId = dataApi['client_id'];
      dataUser.clientSecret = dataApi['client_secret'];
    }

    dataUser.isEmployee = email.endsWith('@sloyd.ai');
    yield put(actions.user.patch(dataUser));

    if (isAlpha) {
      yield put(actions.user.patch({ isAlpha: true }));
      yield put(actions.appState.patch({ isSlimVersion: false }));
      setBoolean('isAlpha', true);
      // yield put($a('TESTERS', 'intro'));
    }

    idbPatchState({ user: dataUser });

    l('api|fetchUser');

    const resApiKey = yield api.user.getApi();

    if (!resApiKey.isSuccess) {
      return;
    }

    const { client_id, client_secret } = resApiKey.data;
    yield put(actions.user.patch({ clientId: client_id, clientSecret: client_secret }));

    console.timeEnd('saga|fetchUser');
  } catch (err) {
    invokeEvent('sentry', { err });
    console.timeEnd('saga|fetchUser');
  }
}

export function* generateApiKey() {
  try {
    const res = yield api.user.rotateApi();
    const { isSuccess } = res;

    if (!isSuccess) {
      toast.error('Failed to generate API key');
      return;
    } else {
      toast.show('API key generated successfully');
    }

    const { client_id, client_secret } = res.data;
    yield put(actions.user.patch({ clientId: client_id, clientSecret: client_secret }));
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

// Root saga
export function* root(): Generator<any, void, any> {
  l('saga|saga.user listening for AUTH_COMPLETED custom event');
  let channel;

  channel = customEventChannel('AUTH_COMPLETED');
  yield takeEvery(channel, fetchUser);

  channel = customEventChannel('REFRESH_USER');
  yield takeEvery(channel, fetchUser);

  channel = customEventChannel('REFRESH_CREDITS');
  yield takeEvery(channel, fetchUser);

  yield takeEvery('GENERATE_API_KEY', generateApiKey);
}

// Export saga
export const saga = {
  id: 'sloyd.user',
  type: 'bootstrap',
  root,
  trigger: {},
};
